import getDisplayName from "../lib/getDisplayName";
import Loading from "./Loading";
import React, { lazy, Suspense } from "react";

const withAphroditeStyles = (aStyles) => {
	return function (WrappedComponent) {
		class EnhancedComponent extends React.Component {
			render() {
				return <WrappedComponent {...this.props} aStyles={aStyles} />;
			}
		}
		EnhancedComponent.displayName = `WithAphroditeStyles(${getDisplayName(WrappedComponent)})`;
		return EnhancedComponent;
	};
};

const DocketLoadable = ({ loader, aStyles, ...opts }) => {
	const LazyComponent = lazy(loader);
	const EnhancedLoading = withAphroditeStyles(aStyles)(Loading);

	return function DocketLoadableWrapper(props) {
		return (
			<Suspense fallback={<EnhancedLoading />}>
				<LazyComponent {...props} {...opts} />
			</Suspense>
		);
	};
};

export default DocketLoadable;
